import { ApplicationConfig,  provideZoneChangeDetection, Injector, Provider, PLATFORM_ID } from '@angular/core';
import { provideAppInitializer, inject, importProvidersFrom } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideStorage, Storage, StorageConfigToken } from '@ionic/storage-angular';
import { StorageConfig, Drivers } from '@ionic/storage';
import { RouteReuseStrategy } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { isPlatform } from '@ionic/angular';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { SettingsService } from './services/settings.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalsService } from './services/globals.service';
import { UtilService } from './services/util.service';
import { CameraService } from './services/camera.service';
import { JobsService } from './services/jobs.service';
import { UserService } from './services/user.service';
import { ConnectionService } from './services/connection.service';
import { TrackingService } from './services/tracking.service';
import { Events } from './services/events.service';
import { StorageService } from './services/storage.service';

// export function createTranslateLoader(http: HttpClient) {
//     return new TranslateHttpLoader('../assets/i18n/');
// }

function provideIonicStorage(storageConfig?: StorageConfig): Provider[] {
    return [
        { provide: StorageConfigToken, useValue: storageConfig },
        { provide: Storage, useFactory: provideStorage, deps: [PLATFORM_ID, StorageConfigToken] },
    ];
}

const getConfig = () => isPlatform('ios') ? {
  backButtonText: 'Zurück',
  innerHTMLTemplatesEnabled: true
} : {
  innerHTMLTemplatesEnabled: true
};

export function initializeApp(settings: SettingsService) {
    return (): Promise<any> => {
        return settings.loadConfig();
    }
}

export const appInitializerFactory = (translate: TranslateService, injector: Injector) =>
  () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const langToSet = 'de';
      translate.setFallbackLang('de');
      translate.use(langToSet).subscribe({
        next: () => {
          console.log(`Successfully initialized '${langToSet}' language.'`);
        },
        error: () => {
          console.error(`Problem with '${langToSet}' language initialization.'`);
        },
        complete: () => {
          resolve(null);
        }
      });
    });
  });

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideIonicAngular(getConfig()),
        provideIonicStorage({ driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage] }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '../assets/i18n/',
                suffix: '.json'
            }),
            fallbackLang: 'en',
            lang: 'de'
        }),
        importProvidersFrom(
            BrowserModule,
            AppRoutingModule,            
            FormsModule),
        SettingsService,
        CameraService,
        ConnectionService,
        Events,
        GlobalsService,
        JobsService,
        StorageService,
        TrackingService,
        UserService,
        UtilService,
        provideAppInitializer(() => {
          const initializerFn = (initializeApp)(inject(SettingsService));
          return initializerFn();
        }),

        provideAppInitializer(() => {
          const initializerFn = appInitializerFactory(inject(TranslateService), inject(Injector));
          return initializerFn();
        }),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideMatomo({
                siteId: 12,
                trackerUrl: 'https://stats.apps.eftas.com/matomo.php',
                scriptUrl: 'https://stats.apps.eftas.com/matomo.js'
            }, 
            withRouter()
        ),
        
        // TranslateModule.forRoot({
        //     fallbackLang: 'en',
        //     loader: {
        //         provide: TranslateLoader,
        //         useFactory: (createTranslateLoader),
        //         deps: [HttpClient]
        //     }
        //     })),
        // { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // provideCharts(withDefaultRegisterables()),
        
        
        provideHttpClient(withInterceptorsFromDi()),
        
    
    ]
}